function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_752",
  "data-name": "Path 752",
  d: "M19,14.182a.546.546,0,0,0-.545.545v5.455a1.638,1.638,0,0,1-1.636,1.636H11.909V5.012a2.351,2.351,0,0,0-1.428-2.164l-4.1-1.756H16.818a1.638,1.638,0,0,1,1.636,1.636V8.182a.545.545,0,1,0,1.091,0V2.727A2.731,2.731,0,0,0,16.818,0H3.727A.535.535,0,0,0,3.6.025,2.321,2.321,0,0,0,3.355,0,2.359,2.359,0,0,0,1,2.355V21.17a2.351,2.351,0,0,0,1.428,2.164l6.2,2.656a2.356,2.356,0,0,0,3.285-2.164v-.917h4.909a2.731,2.731,0,0,0,2.727-2.727V14.727A.546.546,0,0,0,19,14.182Zm-8.182,9.645a1.266,1.266,0,0,1-1.763,1.163l-6.2-2.656a1.265,1.265,0,0,1-.767-1.163V2.355A1.266,1.266,0,0,1,3.355,1.091a1.244,1.244,0,0,1,.5.1l6.2,2.655a1.265,1.265,0,0,1,.767,1.163ZM9.182,12a.546.546,0,0,0-.545.545v2.182a.545.545,0,1,0,1.091,0V12.545A.546.546,0,0,0,9.182,12Zm15.789-.689a.6.6,0,0,0-.012-.061.527.527,0,0,0-.125-.185L21.567,7.8a.545.545,0,0,0-.771.771l2.34,2.34h-9.59a.545.545,0,0,0,0,1.091h9.592L20.8,14.342a.546.546,0,0,0,.771.772l3.273-3.273c.015-.015.021-.035.034-.05a.528.528,0,0,0,.084-.128.52.52,0,0,0,.029-.146A.435.435,0,0,0,25,11.455.528.528,0,0,0,24.971,11.311Z",
  transform: "translate(-1)",
  fill: "#bc3535"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1038",
    "data-name": "Group 1038",
    width: 24,
    height: 26.182,
    viewBox: "0 0 24 26.182",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.f5e614c4.svg";
export { ForwardRef as ReactComponent };